import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "i1004693445__a" }, [
        _createElementVNode("rect", {
          width: "24",
          height: "24",
          rx: "0"
        })
      ])
    ], -1),
    _createElementVNode("g", { "clip-path": "url(#i1004693445__a)" }, [
      _createElementVNode("path", {
        fill: "#743A3A",
        d: "m23.596 10.399-3.025 7.605h-2.574c.114-.93.285-2.154.513-3.674a35.81 35.81 0 0 1-.82 2.024l-.712 1.65h-2.58l1.074-7.605h2.044c-.039.199-.263 1.65-.672 4.355a402.4 402.4 0 0 1 1.723-4.355h1.963l-.71 4.355c.424-1.272 1.002-2.724 1.734-4.356h2.042Zm-9.328 3.753h-3.25l-.476 1.838c-.1.384-.137.632-.112.743.026.111.115.167.268.167.19 0 .337-.074.44-.221.102-.147.208-.433.317-.855l.29-1.121h2.38l-.162.627c-.136.526-.273.93-.41 1.211-.137.282-.365.583-.684.903-.32.32-.68.56-1.085.72-.404.16-.879.241-1.426.241-.53 0-.978-.079-1.343-.237-.365-.158-.625-.374-.779-.65a1.844 1.844 0 0 1-.234-.91c0-.33.08-.812.244-1.444l.642-2.478c.192-.744.441-1.33.747-1.759a2.96 2.96 0 0 1 1.212-.986 3.862 3.862 0 0 1 1.617-.343c.705 0 1.25.138 1.636.413.387.276.613.64.68 1.095.066.455-.007 1.095-.22 1.919l-.292 1.127Zm-2.076-3.05c-.174 0-.296.055-.365.164-.07.109-.166.402-.29.88l-.16.622h.732l.161-.621c.114-.44.164-.724.152-.852-.012-.128-.089-.192-.23-.192ZM10.11 9.388a3.24 3.24 0 0 0-1.335 1.05c-.337.456-.611 1.08-.823 1.87l-.707 2.638c-.18.672-.27 1.185-.268 1.537.002.352.087.674.257.967.17.293.456.524.858.692.017.007.036.011.053.018l-.067.246H5.065l-.184-5.823-1.603 5.823H.404l3.527-12.81h2.874l.338 5.768 1.589-5.768h2.873l-.994 3.612c-.17.05-.339.108-.501.18Z"
      })
    ], -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "new"}) } }